exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-caff6f5c], .fade-leave-active[data-v-caff6f5c] {\n  transition: opacity .5s;\n}\n.fade-enter[data-v-caff6f5c], .fade-leave-to[data-v-caff6f5c] {\n  opacity: 0;\n}\n.sidebar-cover[data-v-caff6f5c] {\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  height: 100%;\n  z-index: 19;\n}\n.loading[data-v-caff6f5c] {\n  text-align: center;\n  padding-top: 50px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-caff6f5c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 90
// module chunks = 0